import { HighlightCta } from '@americastestkitchen/mise';
import Reviewable from 'components/modules/QuickView/components/Reviewable/Reviewable';
import BookQueryContext from 'components/providers/BookQueryContext';
import { QuickViewContext } from 'contexts/QuickViewContext';
import { MouseEvent, useContext } from 'react';
import { AnalyticsAttributes } from 'types/analytics';

type TasteTestButtonProps = {
  text: string;
  reviewable: any; // TODO: add in typing for taste test winner
};

const TasteTestButton = ({ text, reviewable }: TasteTestButtonProps) => {
  const { setContent, isOpen } = useContext(QuickViewContext);
  const bookQueries = useContext(BookQueryContext);
  const { documentId, documentTitle, documentType } = reviewable;

  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    const analyticsAttributes = {
      documentId,
      documentTitle,
      documentType,
      type: 'ingredient',
    } as AnalyticsAttributes;
    setContent(
      reviewable.documentId,
      <Reviewable bookQueries={bookQueries} reviewable={reviewable} />,
      e.currentTarget,
      analyticsAttributes,
    );
  };

  return (
    <HighlightCta
      as="button"
      variant="secondary"
      displayType="inline"
      typography={{
        type: 'open',
        weight: 'normal',
        size: 'lg',
      }}
      onClick={onClick}
      type="button"
      aria-expanded={isOpen}
      aria-controls="quickview_panel"
      aria-description="open quickview"
    >
      {text}
    </HighlightCta>
  );
};

export default TasteTestButton;
